import React, { useCallback, useEffect, useState } from "react";
import { ConnectedProps, connect } from "react-redux";
import { detailTransactionSelector } from "reducers/detailTransaction";
import { actions as transactionActions } from "reducers/transactions";
import { AppDispatch, RootState } from "store";
import { DetailTransaction } from "./DetailTransaction";
import { DetailTransactionContainerType } from "./types";
import { sessionSelector } from "reducers/session";
import useBasicData from "hooks/useBasicData";

const DetailTransactionContainer: React.FC<
  DetailTransactionContainerType & ConnectorProps
> = (props): JSX.Element => {
  useBasicData(["relationships"]);
  const [resolutionHeightModal, setresolutionHeightModal] = useState(496);
  const resizeModal = () => {
    if (window.innerHeight < 720) {
      setresolutionHeightModal((resolutionHeightModal) =>
        resolutionHeightModal !== 496 ? 496 : resolutionHeightModal
      );
    } else if (window.innerHeight >= 720 && window.innerHeight <= 900) {
      setresolutionHeightModal((resolutionHeightModal) =>
        resolutionHeightModal !== 620 ? 620 : resolutionHeightModal
      );
    } else if (window.innerHeight > 900) {
      setresolutionHeightModal((resolutionHeightModal) =>
        resolutionHeightModal !== 675 ? 675 : resolutionHeightModal
      );
    }
  };
  useEffect(() => {
    resizeModal();
  }, [props.isOpen]);

  const handleClose = useCallback(() => {
    props.closeModalDetailTransaction();
  }, [props]);

  return (
    <DetailTransaction
      {...props}
      resolutionHeightModal={resolutionHeightModal}
      handleClose={handleClose}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  detailTransaction: detailTransactionSelector(state).detailTransaction,
  countryCode: sessionSelector(state).countryCode,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  closeModalDetailTransaction: () => {
    dispatch(transactionActions.getCloseModalDetailTransaction());
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector>;

export default connector(DetailTransactionContainer);
